import { gql } from "graphql-request";
import { createGraphQLClient } from "./graphql.service";

const createFileUploadMutation = gql`
  mutation createFileUpload {
    createUpload {
      id
      url
    }
  }
`;

interface CreateFileUploadResponse {
  createUpload: {
    id: string;
    url: string;
  };
}

export const createFileUpload = async () => {
  try {
    const client = createGraphQLClient();
    const response = await client.request<CreateFileUploadResponse>(createFileUploadMutation);

    return response.createUpload;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fileByIdQueryDocument = gql`
  query createFileUpload($id: ID!) {
    pyloMediaById(id: $id) {
      data {
        id
        url
      }
    }
  }
`;

interface FileByIdResponse {
  pyloMediaById: {
    data: {
      id: string;
      url: string;
    };
  };
}
export const downloadFileById = async ({ id }: { id: string }) => {
  try {
    const client = createGraphQLClient();
    const response = await client.request<FileByIdResponse>(fileByIdQueryDocument, { id });
    return response.pyloMediaById.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
